import { render, staticRenderFns } from "./see-more-btn-wraper.vue?vue&type=template&id=18b4270a&"
import script from "./see-more-btn-wraper.vue?vue&type=script&lang=js&"
export * from "./see-more-btn-wraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports